import { lazy } from 'react';

const IndicatorAnalyticsPlanScopeModal = lazy(
  () => import('./ChoosePlanScopeModal'),
);

export default {
  INDICATOR_ANALYTICS_PLAN_SCOPE_MODAL: IndicatorAnalyticsPlanScopeModal,
};
